import { createBreakpoints } from 'planoplan-ui-kit/core/helpers/create-breakpoints';

const points = [
  {
    mobile: 0,
  },
  {
    tablet_portrait: 670,
  },
  {
    tablet_landscape: 1024,
  },
  {
    laptop: 1280,
  },
  {
    laptop_wide: 1440,
  },
  {
    fullhd: 1920,
  },
  {
    ultrahd: 2400,
  },
];

export const Points = createBreakpoints(points);
